// this file added by Bearer Web Developer
import { Button } from "@mui/material";
import React from "react";
import styles from './deliveryPhoto.module.scss';
import ImagePopup from "./imagePopup";
import { useThemeMode } from "../../../../../states/contexts/theme";
interface Props {
    url: string
}

const DeliveryPhoto: React.FC<Props> = ({ url }) => {
    const [open, setOpen] = React.useState(false);
    const handleClose = () => { setOpen(false); };
    const handleOpen = () => { setOpen(true); };
    const { theme } = useThemeMode(); // added by Bearer Web Developer
    return (
        <>
            <div className={styles.delivery_photo} data-theme={theme}> {/* data-theme property added by Bearer Web Developer */}
                <Button onClick={handleOpen}>
                    <img src="/photo-camera.svg" alt="" width={20} height={20} />
                  <h5> Check Verification Photo</h5> 
                </Button>
            </div>
            <ImagePopup url={url} open={open} handleClose={handleClose} />
        </>
    )
}
export default DeliveryPhoto;